document.addEventListener('alpine:init', () => {
  Alpine.data('marquee', ({ speed = 50, direction = 'left' }) => ({
    speed,
    direction,
    inner: null,
    clone: null,
    units: [],        // [inner, clone, extra...]
    unitWidth: 0,
    offset: 0,
    anim: null,
    running: false,
    lastTime: null,
    resizeObs: null,

    initObserver() {
      this.inner = this.$refs.inner;
      this.clone = this.$refs.clone;

      // Seed clone
      this.clone.innerHTML = this.inner.innerHTML;
      this.clone.className = this.inner.className;

      // Build initial set
      this.buildUnits();

      // Start/stop on visibility
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => entry.isIntersecting ? this.start() : this.stop());
      }, { threshold: 0.1 });
      observer.observe(this.$root);

      // --- NEW: Rebuild on resize/content reflow (responsive CSS, fonts, etc.) ---
      this.resizeObs = new ResizeObserver(() => this.onResize());
      this.resizeObs.observe(this.$root);
      this.resizeObs.observe(this.inner);
    },

    buildUnits() {
      // Remove previously added extra clones
      this.$root.querySelectorAll('[data-marquee-unit]').forEach(el => el.remove());

      // Measure one unit width
      this.unitWidth = this.inner.offsetWidth || 1;

      // Count how many units are needed: viewport + buffer(2)
      const vw = this.$root.clientWidth || window.innerWidth;
      const neededVisible = Math.ceil(vw / this.unitWidth);
      const totalUnits = Math.max(neededVisible + 2, 2);

      // Collect units: originals first
      this.units = [this.inner, this.clone];

      // Create extra clones
      for (let i = 2; i < totalUnits; i++) {
        const c = this.inner.cloneNode(true);
        c.removeAttribute('x-ref');
        c.setAttribute('data-marquee-unit', '');
        c.className = this.inner.className;
        this.$root.appendChild(c);
        this.units.push(c);
      }

      // Initial offset for first build (kept minimal)
      // For right we start at -w so viewport is filled immediately
      if (this.lastTime === null && this.offset === 0 && this.direction === 'right') {
        this.offset = -this.unitWidth;
      }

      this.applyTransforms();
    },

    // --- NEW: Smooth rebuild on resize with phase preservation ---
    onResize() {
      const oldW = this.unitWidth || this.inner.offsetWidth || 1;
      const oldOffset = this.offset;

      // Rebuild units for new widths / count
      this.buildUnits();

      const newW = this.unitWidth || 1;

      // Preserve visual phase: scale offset proportionally
      // (offset is always in (-W, 0] range)
      this.offset = (oldOffset / oldW) * newW;

      // Normalize to (-newW, 0]
      while (this.offset <= -newW) this.offset += newW;
      while (this.offset > 0) this.offset -= newW;

      this.applyTransforms();
    },

    tick(timestamp) {
      if (!this.running) return;

      if (!this.lastTime) this.lastTime = timestamp;
      const delta = (timestamp - this.lastTime) / 1000; // seconds
      this.lastTime = timestamp;

      const dist = this.speed * delta; // px/sec

      if (this.direction === 'left') {
        this.offset -= dist;
        if (this.offset <= -this.unitWidth) this.offset += this.unitWidth; // wrap left
      } else {
        this.offset += dist;
        if (this.offset >= 0) this.offset -= this.unitWidth; // wrap right
      }

      this.applyTransforms();
      this.anim = requestAnimationFrame((t) => this.tick(t));
    },

    applyTransforms() {
      const w = this.unitWidth;
      for (let i = 0; i < this.units.length; i++) {
        const x = this.offset + i * w; // same formula for both directions
        this.units[i].style.transform = `translateX(${x}px)`;
      }
    },

    start() {
      if (this.running) return;
      this.running = true;
      this.lastTime = null;
      this.anim = requestAnimationFrame((t) => this.tick(t));
    },

    stop() {
      this.running = false;
      if (this.anim) cancelAnimationFrame(this.anim);
      this.anim = null;
      this.lastTime = null;
    }
  }))
});